var url = process.env.GATSBY_NETLIFY
  ? "https://api.instantoutreach.org"
  : "/api"

module.exports = {
  apiURL: url, // TODO: add production switch
}
